import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SharedModule } from '@tv3/shared/shared.module'
import { AgodaContentModule } from './agoda/agoda-content.module'
import { BdcContentModule } from './bdc/bdc-content.module'

const components = []

const services = [
  //
]

const modules = [BdcContentModule, AgodaContentModule]

@NgModule({
  imports: [SharedModule, CommonModule, ...modules],
  declarations: [...components],
  exports: [...components, ...modules],
  providers: [...services],
})
export class ChannelContentModule {}
